import {CategoryHighlightSection_Element} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import React from 'react';
import {CategoryHighlightSectionProductListDeferred} from './CategoryHighlightSectionProductListDeferred';
import {CategoryHighlightSectionProductListView} from './CategoryHighlightSectionProductListView';

export const CategoryHighlightSectionProductList: React.FC<{
  content: CategoryHighlightSection_Element['content'];
  setCardProductIds: (productIds: number[]) => void;
}> = ({content, ...rest}) => {
  switch (content?.$case) {
    case 'body':
      return (
        <CategoryHighlightSectionProductListView
          body={content.body}
          {...rest}
        />
      );
    case 'deferred':
      return (
        <CategoryHighlightSectionProductListDeferred
          deferred={content.deferred}
          {...rest}
        />
      );
  }
};
